// 공개 사이트(랜딩/연구소개/기관/연구성과) 공용 셸에서 쓰는 고정 텍스트 상수 모음.
// 헤더 워드마크·내비게이션, 대시보드 복귀 라벨, 하단 Contact/저작권 스트립을
// 모든 공개 페이지가 공유하므로 여기 한 곳에서 관리한다.

export interface SiteNavLink {
  label: string;
  to: string;
  children?: SiteNavLink[];
}

export const SITE_WORDMARK = "Mindcast system";
export const SITE_BACK_TO_APP_LABEL = "대시보드로";

// 헤더 내비게이션 — 이제 imweb.me 로 나가는 외부 링크가 아니라 내부 라우트다.
// "주관 / 서강대학교" 항목은 hover/focus 시 서브메뉴(3개 서강대 slug)를 보여준다.
export const SITE_NAV_LINKS: SiteNavLink[] = [
  { label: "연구 소개", to: "/about" },
  { label: "이용 안내", to: "/guide" },
  {
    label: "주관 / 서강대학교",
    to: "/institutions/sogang-comm",
    children: [
      { label: "신문방송학과", to: "/institutions/sogang-comm" },
      { label: "컴퓨터공학과(머신러닝)", to: "/institutions/sogang-ml" },
      { label: "컴퓨터공학과(데이터)", to: "/institutions/sogang-data" },
    ],
  },
  { label: "1공동 / 고려대학교", to: "/institutions/korea-psychiatry" },
  { label: "2공동 / 액스콘", to: "/institutions/axcon" },
  { label: "연구성과", to: "/community" },
];

export interface SiteContactField {
  label: string;
  value: string;
  href?: string;
}

// Footer 상단 "Contact us." 블록 — imweb 원본 공개 정보를 그대로 옮긴다.
// 모든 공개 페이지 하단에 공통으로 노출된다.
export const SITE_CONTACT_HEADING = "Contact us.";
export const SITE_CONTACT_FIELDS: SiteContactField[] = [
  { label: "연구 책임자", value: "유현재" },
  { label: "주소", value: "서강대학교 가브리엘관" },
  { label: "전화", value: "02-705-8847" },
  {
    label: "이메일",
    value: "mindcast.system@gmail.com",
    href: "mailto:mindcast.system@gmail.com",
  },
];
